import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { useConnectionCheckPolling } from "./useConnectionCheckPolling";

/**
 * バックエンドに正常に接続出来ているかを確認する
 */
export const useIsConnectionOk = () => {
  const $ = _c(7);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      pollInterval: 1000
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    error,
    loading
  } = useConnectionCheckPolling(t0);
  const [isConnectionOk, setIsConnectionOk] = useState(false);
  let t1;
  let t2;
  if ($[1] !== error || $[2] !== loading) {
    t1 = () => {
      if (!error && !loading) {
        setIsConnectionOk(true);
      }
    };
    t2 = [error, loading];
    $[1] = error;
    $[2] = loading;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  if ($[5] !== isConnectionOk) {
    t3 = {
      isConnectionOk
    };
    $[5] = isConnectionOk;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};